import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@papier/ui/lib/utils";

const alertVariants = cva(
  "relative grid w-full grid-cols-[0_1fr] items-start gap-y-0.5 rounded-2xl border px-4 py-3.5 text-sm backdrop-blur-sm has-[>div:has(>svg)]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>div:has(>svg)]:gap-x-3 has-[>iconify-icon]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>iconify-icon]:gap-x-3 has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>svg]:gap-x-3 [&>div:has(>iconify-icon)]:size-4 [&>div:has(>iconify-icon)]:translate-y-0.5 [&>div:has(>iconify-icon)]:text-current [&>div:has(>svg)]:size-4 [&>div:has(>svg)]:translate-y-0.5 [&>div:has(>svg)]:text-current [&>iconify-icon]:size-4 [&>iconify-icon]:translate-y-0.5 [&>iconify-icon]:text-current [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "border-border/40 bg-card/60 text-card-foreground backdrop-blur-sm",
        destructive:
          "border-destructive/30 bg-destructive/5 text-destructive *:data-[slot=alert-description]:text-destructive/80 dark:border-destructive/40 dark:bg-destructive/10 [&>svg]:text-current",
        success:
          "border-success/30 bg-success/5 text-success *:data-[slot=alert-description]:text-success dark:border-success/40 dark:bg-success/10 [&>svg]:text-current",
        warning:
          "border-warning/30 bg-warning/5 text-warning-foreground *:data-[slot=alert-description]:text-warning-foreground/90 dark:border-warning/40 dark:bg-warning/10 dark:text-warning dark:*:data-[slot=alert-description]:text-warning/90 [&>svg]:text-current",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof alertVariants>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  );
}

function AlertTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-title"
      className={cn("col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight", className)}
      {...props}
    />
  );
}

function AlertDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        "col-start-2 grid justify-items-start gap-1 text-sm text-muted-foreground [&_p]:leading-relaxed",
        className,
      )}
      {...props}
    />
  );
}

export { Alert, AlertDescription, AlertTitle };
